import { RouteConfig } from 'vue-router'
import { requireAuth } from '../auth'
import { saasRoutes } from '../constants/agency/'

const SaasRoot = () =>
  import(
    /* webpackChunkName: "saas-dashboard" */ '@/pmd/pages/saas/SaasRoot.vue'
  ).then(m => m.default)

const SaasBuilder = () =>
  import(
    /* webpackChunkName: "saas-dashboard" */ '@/pmd/pages/saas/SaasBuilder.vue'
  ).then(m => m.default)

const SaasBuilderLabs = () =>
  import(
    /* webpackChunkName: "saas-dashboard" */ '@/pmd/pages/saas/SaasBuilderLabs.vue'
  ).then(m => m.default)

const SaasEducation = () =>
  import(
    /* webpackChunkName: "saas-education" */ '@/pmd/pages/agency/SaasEducation.vue'
  ).then(m => m.default)

const SaasFasttrack = () =>
  import(
    /* webpackChunkName: "saas-fasttrack" */ '@/pmd/pages/agency/SaasFasttrack.vue'
  ).then(m => m.default)

export const saas: RouteConfig[] = [
  {
    path: '/saas_dashboard',
    name: saasRoutes.default,
    component: SaasRoot,
    beforeEnter: requireAuth,
    children: [
      {
        path: '',
        name: saasRoutes.builderLabs,
        component: SaasBuilderLabs,
      },
      {
        path: 'plan/:planId/update',
        name: saasRoutes.planUpdate,
        component: SaasBuilder,
      },
      {
        path: 'plan/create',
        name: saasRoutes.planCreate,
        component: SaasBuilder,
      },
    ],
  },
  {
    path: '/saas_education',
    name: saasRoutes.education,
    component: SaasEducation,
    beforeEnter: requireAuth,
  },
  {
    path: '/saas_fasttrack',
    name: saasRoutes.fastTrack,
    component: SaasFasttrack,
    beforeEnter: requireAuth,
  },
]
